import React from "react";

export const PsTreeResizeHandle = React.forwardRef((props: any, ref) => {
  const { handleAxis, ...restProps } = props;
  return (<div
    ref={ref}
    className={`splitter handle-${String(handleAxis)}`}
    {...restProps}
  // style={{
  //   // width: '23px',
  //   // cursor: 'col-resize',
  // }}
  />
  );
});